import React from 'react';
import TextHelpField from '@/modules/common/components/TextHelpField';
import Table from './Table';

const TextFieldPostBackUrl = (props) => {
    return (
        <TextHelpField label="URL" popover={{id: 'popover-postback-url', position: 'right'}} {...props}>
            <Table/>
        </TextHelpField>
    );
};

export default TextFieldPostBackUrl;
